/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfboolean
 */
export interface ApiResultOfboolean {
    /**
     * 
     * @type {boolean}
     * @memberof ApiResultOfboolean
     */
    data?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfboolean
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfboolean
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfboolean
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfboolean
     */
    result?: ApiResultOfbooleanResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfbooleanResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfbooleanFromJSON(json: any): ApiResultOfboolean {
    return ApiResultOfbooleanFromJSONTyped(json, false);
}

export function ApiResultOfbooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfboolean {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfbooleanToJSON(value?: ApiResultOfboolean | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

